import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';
import { IFormEmergencyServicesOptions } from '../../../../Models/Forms/IFormEmergencyServicesOptions';
import { FormEmergencyServicesOptionsService } from '../../../../Services/FormEmergencyServicesOptions.service';

@Component({
  selector: 'app-emergency-service-options',
  templateUrl: './emergency-service-options.component.html',
  styleUrls: ['./emergency-service-options.component.css']
})
export class EmergencyServiceOptionsComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  emergencyServiceOptionsDb: IFormEmergencyServicesOptions;
  reportParamArray: IReportParameter[];

  constructor(
    private globals: Globals, reportService: ReportService,
    iepService: IepService,
    private _emergencyServiceOptionsService: FormEmergencyServicesOptionsService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router) {
    super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance
  }

  ngOnInit(): void {
    this.loadForm();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    //
    this.emergencyServiceOptionsDb = {} as IFormEmergencyServicesOptions;
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
    let today = new Date();
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.loadForm();
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  loadForm() {
    this._emergencyServiceOptionsService.getFormEmergencyServices(this._myGlobals.selectedFormDetails.formId).subscribe(
      (res: IFormEmergencyServicesOptions) => {
        this.emergencyServiceOptionsDb = res;

        //TODO: set field visibility if needed
        //translate dates if needed
      },
      err => console.error(err)
    );   
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  onEsyApplicableToggle() {
    if (this.emergencyServiceOptionsDb.esyNotApplicable) {
      this.emergencyServiceOptionsDb.esyTeacherPostedLessons = false;
      this.emergencyServiceOptionsDb.esyVirtualClassMeetings = false;
      this.emergencyServiceOptionsDb.esyPersonalizedLearningTools = false;
      this.emergencyServiceOptionsDb.esyScheduledTeacherAppointments = false;
      this.emergencyServiceOptionsDb.esyScheduledEmailCheckins = false;
      this.emergencyServiceOptionsDb.esyVirtualOfficeHours = false;
      this.emergencyServiceOptionsDb.esyOther = '';
      this.emergencyServiceOptionsDb.esyComments = '';
    }
  }

  onTsApplicableToggle() {
    if (this.emergencyServiceOptionsDb.tsNotApplicable) {
      this.emergencyServiceOptionsDb.tsTeacherPostedLessons = false;
      this.emergencyServiceOptionsDb.tsVirtualClassMeetings = false;
      this.emergencyServiceOptionsDb.tsPersonalizedLearningTools = false;
      this.emergencyServiceOptionsDb.tsScheduledTeacherAppointments = false;
      this.emergencyServiceOptionsDb.tsScheduledEmailCheckins = false;
      this.emergencyServiceOptionsDb.tsVirtualOfficeHours = false;
      this.emergencyServiceOptionsDb.tsOther = '';
      this.emergencyServiceOptionsDb.tsComments = '';
    }
  }

  populateReportParameters() {
    this.reportParamArray = [];
    //this.reportParamArray.push(
    //  { parameterName: 'dtFrmEdited', parameterValue: this.emergencyServiceOptionsDb.updatedOn.toString() },
    //  { parameterName: 'RequestID', parameterValue: '0' },
    //  { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False' },
    //  { parameterName: 'FormInstanceID', parameterValue: this.emergencyServiceOptionsDb.iepFormInstanceId.toString() },
    //  { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
    //  { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
    //  { parameterName: 'FormVersionID', parameterValue: '' },
    //  { parameterName: 'StudentID', parameterValue: this.emergencyServiceOptionsDb.localStudentId.toString() },
    //  { parameterName: 'IEPID', parameterValue: '' },
    //  { parameterName: 'BlankForm', parameterValue: 'false' },
    //);
    this.reportParamArray.push(
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False' },
      { parameterName: 'FormInstanceID', parameterValue: this.emergencyServiceOptionsDb.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.emergencyServiceOptionsDb.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.emergencyServiceOptionsDb.rdlFileNameSpanish, this.reportParamArray);
  }

  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;

    //update values

    if (this.emergencyServiceOptionsDb.ssid == null || this.emergencyServiceOptionsDb.ssid == '') {
      this.emergencyServiceOptionsDb.ssid = this._myGlobals.selectedStudent.ssid;
    }

    this._emergencyServiceOptionsService.insertUpdateFormEmergencyServices(this.emergencyServiceOptionsDb)
      .subscribe((res: IFormEmergencyServicesOptions) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.loadForm();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }
  
}
